import React from 'react';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import OfferOverlayOrClickLinkWrap from 'core/modules/OfferOverlayOrClickLinkWrap/OfferOverlayOrClickLinkWrap';
import './FeaturedOffer120x90.scss';

const FeaturedOffer120x90 = ({ dataItem, sectionId, useAddToFavorite }) => {
  const {
    assets: {
      _120x90,
      imageAlternateText,
    },
    merchant: { id, name, rebate },
  } = dataItem;

  return (
    <div
      className="mn_featuredOffer120x90"
      data-test="featured-offer-120x90"
      data-section-type="120x90 text offer"
      data-merchant-name={name}
    >
      {useAddToFavorite && <FavoriteIcon merchantId={id} merchantName={name} />}
      <OfferOverlayOrClickLinkWrap
        dataItem={dataItem}
        sectionId={sectionId}
        className="mn_featuredOffer120x90LinkOrOverlayWrap"
      >
        <div className="mn_logoWrap">
          <img className="mn_featureOfferImage" src={_120x90} alt={imageAlternateText} />
        </div>
        <div className="mn_merchantRebateWrap" data-test="featured-offer-120x90-rebate">
          <ExtraRewardsPill rebate={rebate} label="Extra" />
          <MerchantRebateV2 {...rebate} hideRebatePrefix hideElevationCurrency />
        </div>
      </OfferOverlayOrClickLinkWrap>
    </div>
  );
};

export default FeaturedOffer120x90;
